import { Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";

import "./styles/main.css";

// import Dashboard from "./pages/dashboard.js";
import Login from "./pages/login.js";
import Refunds from "./pages/refunds";
import Wrapper from "./pages/wrapper";
import ResetPassword from "./pages/reset";
import ResetPasswordCommit from "./pages/reset.commit";
import Users from "./pages/users";
import Credits from "./pages/credits";
import Invoices from "./pages/invoices";
import Settings from "./pages/settings";
import Impersonate from "./pages/impersonate.js";
import ImpersonationTitle from "./components/title_impersonate.js";
import Messages from "./pages/messages.js";
import Notice from "./pages/notice.js";
import Maintenance from "./pages/maintenance.js";
import Blocked from "./pages/blocked.js";

import Store from "./global/global";
import { ImpersonationProvider } from "./global/impersonation.js";
import { MessagesProvider, useMessages } from "./global/messagesContext.js";
import { TourGuiadoProvider } from "./global/tourGuiadoContext";

function App() {

  return (
    <ImpersonationProvider>
      <MessagesProvider>
        <Store>
          <TourGuiadoBootstrap>
            <ImpersonationTitle />
            <InnerApp />
          </TourGuiadoBootstrap>
        </Store>
      </MessagesProvider>
    </ImpersonationProvider>

  );
}

// Le o profile.id de localStorage["data"] (gravado pelo Wrapper apos getProfile)
// e propaga para o TourGuiadoProvider como userId.
//
// Por que polling: o login.js grava localStorage com oauthLogin (sem profile.id).
// Soh depois o Wrapper faz getProfile e sobrescreve com o profile completo.
// O Bootstrap precisa reagir a essa segunda escrita, que acontece pos-mount, na
// mesma aba (eventos `storage` soh disparam em outras abas). Polling de 1.5s eh
// barato (localStorage read em microssegundos) e cobre os casos de login,
// logout e mudancas de profile sem tocar o Wrapper.
//
// Deps `[]`: o setInterval ja cobre todas as mudancas de profile.id no
// localStorage. Re-rodar este useEffect a cada navegacao apenas re-cria o
// interval sem ganho — adiciona churn em paginas que ja sofrem com multiplos
// re-renders (issue conhecida no Wrapper.getProfile).
function TourGuiadoBootstrap({ children }) {
  const [userId, setUserId] = useState(null);
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const tick = () => {
      try {
        const raw = localStorage.getItem("data");
        const parsed = raw ? JSON.parse(raw) : null;
        const id = parsed?.profile?.id || null;
        const perms = parsed?.profile?.permissions || null;
        setUserId((prev) => (prev === id ? prev : id));
        // Compara via JSON pra manter ref estavel quando o objeto e
        // re-emitido com mesmos valores — evita re-render do Provider a cada
        // tick (1.5s).
        setPermissions((prev) => {
          const a = prev ? JSON.stringify(prev) : "";
          const b = perms ? JSON.stringify(perms) : "";
          return a === b ? prev : perms;
        });
      } catch (e) {
        setUserId(null);
        setPermissions(null);
      }
    };
    tick();
    const interval = setInterval(tick, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <TourGuiadoProvider userId={userId} permissions={permissions}>
      {children}
    </TourGuiadoProvider>
  );
}

function InnerApp() {
  const { data, blockScreens } = useMessages();

  const checkBlockedRoute = (param) => {
    return blockScreens.includes('all_access_admin') || blockScreens.includes(param);
  }

  return (
    <Routes>
      <Route path="/refunds" element={<Wrapper screen={checkBlockedRoute("page_refunds_admin") ? <Maintenance title="Despesas" /> : <Refunds />} />} />
      <Route path="/users" element={<Wrapper screen={checkBlockedRoute("page_users_admin") ? <Maintenance title="Usuários" /> : <Users />} />} />
      <Route path="/credits" element={<Wrapper screen={checkBlockedRoute("page_credits_admin") ? <Maintenance title="Créditos" /> : <Credits />} />} />
      <Route path="/invoices" element={<Wrapper screen={<Invoices />} />} />
      <Route path="/settings" element={<Wrapper screen={checkBlockedRoute("settings_admin") ? <Maintenance title="Configurações" /> : <Settings />} />} />
      <Route path="/impersonate" element={<Wrapper screen={<Impersonate />} />} />
      <Route path="/notice" element={<Wrapper screen={(data && data.length > 0) ? <Notice /> : <Maintenance title="Avisos" isNotice={true} />} />} />
      <Route path="/messages" element={<Wrapper screen={<Messages />} />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/reset/:token" element={<ResetPasswordCommit />} />
      <Route path="/blocked" element={<Blocked />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Wrapper screen={checkBlockedRoute("page_refunds_admin") ? <Maintenance title="Despesas" /> : <Refunds />} />} />
    </Routes>
  );
}

export default App;
